import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <div className="space-y-6">
              <section>
                <h2 className="text-2xl font-semibold mb-4">Terms of Service</h2>
                <p className="mb-4">
                  By accessing and using this website, you agree to comply with the following terms and conditions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Website Usage</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>This website is for informational and educational purposes only</li>
                  <li>Prohibited from use for any illegal or unauthorized purposes</li>
                  <li>Do not interfere with the normal operation of the website</li>
                  <li>Do not attempt to access other users' account information</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Content Disclaimer</h2>
                <p className="mb-4">
                  All information provided on this website is for reference only. We do not guarantee the accuracy, completeness, or timeliness of the information.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
                <p className="mb-4">
                  To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of this website.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}